import { FuseLoadable } from '@fuse';

const PriceManagement = {
    auth: ['admin', 'sub-admin'],
    routes: [
        {
            path: '/price-management',
            component: FuseLoadable({
                loader: () => {
                    return import('./PriceManagement');
                },
            }),
        },
    ],
};

export default [PriceManagement];
